// extracted by mini-css-extract-plugin
export default {"svg-container":"TextWithSvg_svg-container__1f2Rs","text-wrapper":"TextWithSvg_text-wrapper__LV-ry","image":"TextWithSvg_image__l-ZWu","wrapper":"TextWithSvg_wrapper__W8zB4"};